module.exports = __webpack_public_path__ + "static/media/chat06.8086428f.svg";